module.exports = __webpack_public_path__ + "static/media/C2QB_green_btn_tall_hover.93b84aa3.svg";